if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
			}

			hide(preventFocus = false) {
				const cartNotification =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				if (cartNotification) cartNotification.setActiveElement(this.openedBy);
				this.modalContent.innerHTML = "";

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");
				opener.querySelector(".loading__spinner").classList.remove("hidden");

				fetch(opener.getAttribute("data-product-url"))
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.productElement.classList.forEach((classApplied) => {
							if (
								classApplied.startsWith("color-") ||
								classApplied === "gradient"
							)
								this.modalContent.classList.add(classApplied);
						});
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						super.show(opener);
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");
						opener.querySelector(".loading__spinner").classList.add("hidden");
					});
			}

			setInnerHTML(element, html) {
				element.innerHTML = html;

				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});
			}

			preventVariantURLSwitching() {
				const variantPicker =
					this.modalContent.querySelector("variant-selects");
				if (!variantPicker) return;

				variantPicker.setAttribute("data-update-url", "false");
			}

			removeDOMElements() {
				const pickupAvailability = this.productElement.querySelector(
					"pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const productModal = this.productElement.querySelector("product-modal");
				if (productModal) productModal.remove();

				const modalDialog =
					this.productElement.querySelectorAll("modal-dialog");
				if (modalDialog) modalDialog.forEach((modal) => modal.remove());
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, product-info")
					.forEach((element) => {
						element.dataset.originalSection = sectionId;
					});
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}

(function () {
	function addQuantityControlsCSS() {
		const styleId = "collection-quantity-controls-inline-css";

		const existingStyle = document.getElementById(styleId);
		if (existingStyle) {
			existingStyle.remove();
		}

		const style = document.createElement("style");
		style.id = styleId;
		style.textContent = `
			.collection-qty-controls {
				display: none !important;
			}
			
			form.in-cart .collection-qty-controls {
				display: flex !important;
			}
			
			form.in-cart [data-collection-add-to-cart] {
				display: none !important;
			}
			
			form[data-collection-qty-init="1"] .collection-qty-controls {
				display: none !important;
			}
			
			form[data-collection-qty-init="1"].in-cart .collection-qty-controls {
				display: flex !important;
			}
		`;
		document.head.appendChild(style);
	}

	function isElementInViewport(el) {
		if (!el) return false;
		const rect = el.getBoundingClientRect();
		const buffer = window.innerHeight * 1.5;
		return rect.top <= window.innerHeight + buffer && rect.bottom >= -buffer;
	}

	function initializeQuantityControls(container = document) {
		const plusButtons = container.querySelectorAll(
			"[data-collection-qty-plus]:not([data-initialized])"
		);
		const minusButtons = container.querySelectorAll(
			"[data-collection-qty-minus]:not([data-initialized])"
		);

		plusButtons.forEach((button) => {
			button.setAttribute("data-initialized", "true");
			button.addEventListener("click", function () {
				const form = this.closest("form");
				if (!form) return;

				showLoadingSpinner(this);

				const qtyInput = form.querySelector("[data-collection-qty-input]");
				if (!qtyInput) return;

				const currentValue = parseInt(qtyInput.value, 10);
				const newValue = currentValue + 1;

				qtyInput.value = newValue;
				updateCartQuantity(form, newValue, this);
			});
		});

		minusButtons.forEach((button) => {
			button.setAttribute("data-initialized", "true");
			button.addEventListener("click", function () {
				const form = this.closest("form");
				if (!form) return;

				showLoadingSpinner(this);

				const qtyInput = form.querySelector("[data-collection-qty-input]");
				if (!qtyInput) return;

				const currentValue = parseInt(qtyInput.value, 10);
				if (currentValue <= 1) {
					qtyInput.value = 0;
					updateCartQuantity(form, 0, this);
					return;
				}

				const newValue = currentValue - 1;
				qtyInput.value = newValue;
				updateCartQuantity(form, newValue, this);
			});
		});
	}

	function updateCartQuantity(form, newQuantity, button = null) {
		if (!form) return;

		// Flag to track if this is a remove operation
		const isRemoveOperation =
			newQuantity === 0 ||
			newQuantity <
				parseInt(
					form.querySelector("[data-collection-qty-input]")?.value || "1"
				);

		form.classList.add("updating");
		const qtyControls = form.querySelector(".collection-qty-controls");
		if (qtyControls) qtyControls.classList.add("loading");

		const variantIdInput = form.querySelector('input[name="id"]');
		if (!variantIdInput) {
			hideLoadingSpinner(button);
			return;
		}

		const variantId = variantIdInput.value;

		fetch("/cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				id: variantId,
				quantity: newQuantity,
			}),
		})
			.then((response) => response.json())
			.then((cart) => {
				form.classList.remove("updating");
				if (qtyControls) qtyControls.classList.remove("loading");
				if (button) hideLoadingSpinner(button);

				updateCartCountBubble(cart);
				updateFormState(form, variantId, newQuantity, cart);

				// Only show notification for additions, not for removals or decreases
				if (!isRemoveOperation && newQuantity > 0) {
					triggerCartNotification(variantId, newQuantity, cart);
				}
			})
			.catch((error) => {
				form.classList.remove("updating");
				if (qtyControls) qtyControls.classList.remove("loading");
				if (button) hideLoadingSpinner(button);
			});
	}

	function updateFormState(form, variantId, quantity, cart) {
		if (!form) return;

		if (quantity <= 0) {
			form.classList.remove("in-cart");

			// Reset quantity input to 1 for next addition
			const qtyInput = form.querySelector("[data-collection-qty-input]");
			if (qtyInput) {
				qtyInput.value = 1;
			}

			return;
		}

		form.classList.add("in-cart");

		const qtyInput = form.querySelector("[data-collection-qty-input]");
		if (qtyInput) {
			qtyInput.value = quantity;
		}
	}

	function triggerCartNotification(variantId, quantity, cart) {
		// For removals, we don't need to show notification
		if (quantity <= 0) {
			return;
		}

		const cartNotification = document.querySelector("cart-notification");
		if (!cartNotification) {
			try {
				if (window.publish) {
					// Only publish cart-update for additions, not for removals
					// This ensures notification doesn't show when clicking the minus button in collection pages
					if (quantity > 0) {
						window.publish("cart-update", {
							cartData: cart,
							key: variantId,
							quantity: quantity,
						});
					}
				}
			} catch (err) {}
			return;
		}

		try {
			// Only render notification for additions, not removals
			if (quantity > 0) {
				cartNotification.renderContents({
					key: variantId,
					items: cart.items,
					sections: cart.sections || {},
				});
			}
		} catch (err) {}
	}

	function initializeAddToCartButtons(container = document) {
		const addButtons = container.querySelectorAll(
			"[data-collection-add-to-cart]:not([data-qty-init])"
		);

		addButtons.forEach((button) => {
			button.setAttribute("data-qty-init", "true");

			button.addEventListener("click", function (e) {
				e.preventDefault();
				const form = this.closest("form");
				if (!form) return;

				this.classList.add("loading");
				const spinner = this.querySelector(".loading__spinner");
				if (spinner) spinner.classList.remove("hidden");

				const formData = new FormData(form);

				fetch("/cart/add.js", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						this.classList.remove("loading");
						if (spinner) spinner.classList.add("hidden");

						form.classList.add("in-cart");

						const qtyInput = form.querySelector("[data-collection-qty-input]");
						if (qtyInput) {
							qtyInput.value = 1;
						}

						return fetch("/cart.js");
					})
					.then((response) => response.json())
					.then((cart) => {
						updateCartCountBubble(cart);
						updateAllFormsFromCart(cart);
						triggerCartNotification(
							form.querySelector('input[name="id"]').value,
							1,
							cart
						);
					})
					.catch((error) => {
						this.classList.remove("loading");
						if (spinner) spinner.classList.add("hidden");
					});
			});
		});
	}

	function updateAllFormsFromCart(cart) {
		if (!cart || !cart.items) {
			return;
		}

		updateCartCountBubble(cart);

		const allForms = document.querySelectorAll('form[action="/cart/add"]');
		allForms.forEach((form) => {
			form.classList.remove("in-cart");
		});

		cart.items.forEach((item) => {
			const variantId = item.variant_id;
			const quantity = item.quantity;

			const variantForms = document.querySelectorAll(
				`form[action="/cart/add"] input[name="id"][value="${variantId}"]`
			);
			variantForms.forEach((input) => {
				const form = input.closest("form");
				if (form) {
					form.classList.add("in-cart");

					const qtyInput = form.querySelector("[data-collection-qty-input]");
					if (qtyInput) {
						qtyInput.value = quantity;
					}
				}
			});
		});
	}

	function initializeOnPageLoad() {
		addQuantityControlsCSS();

		fetch("/cart.js")
			.then((response) => response.json())
			.then((cart) => {
				updateAllFormsFromCart(cart);
				initializeAddToCartButtons();
				initializeQuantityControls();
				setupMutationObserver();
				setupScrollListener();
			})
			.catch((error) => {
				initializeAddToCartButtons();
				initializeQuantityControls();
				setupMutationObserver();
				setupScrollListener();
			});
	}

	function setupMutationObserver() {
		const observer = new MutationObserver((mutations) => {
			let hasNewContent = false;

			mutations.forEach((mutation) => {
				if (mutation.addedNodes.length) {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1) {
							if (
								node.querySelector &&
								(node.querySelector(
									"[data-collection-add-to-cart]:not([data-qty-init])"
								) ||
									node.querySelector(
										"[data-collection-qty-plus]:not([data-initialized])"
									) ||
									node.querySelector(
										"[data-collection-qty-minus]:not([data-initialized])"
									))
							) {
								hasNewContent = true;
							}
						}
					});
				}
			});

			if (hasNewContent) {
				initializeAddToCartButtons();
				initializeQuantityControls();

				fetch("/cart.js")
					.then((response) => response.json())
					.then((cart) => {
						updateAllFormsFromCart(cart);
					})
					.catch((error) => {});
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	function setupScrollListener() {
		let scrollTimeout;
		window.addEventListener("scroll", function () {
			if (scrollTimeout) clearTimeout(scrollTimeout);

			scrollTimeout = setTimeout(function () {
				const uninitializedButtons = document.querySelectorAll(
					"[data-collection-add-to-cart]:not([data-qty-init])"
				);
				const uninitializedControls = document.querySelectorAll(
					"[data-collection-qty-plus]:not([data-initialized]), [data-collection-qty-minus]:not([data-initialized])"
				);

				if (
					uninitializedButtons.length > 0 ||
					uninitializedControls.length > 0
				) {
					initializeAddToCartButtons();
					initializeQuantityControls();

					fetch("/cart.js")
						.then((response) => response.json())
						.then((cart) => {
							updateAllFormsFromCart(cart);
						})
						.catch((error) => {});
				}
			}, 200);
		});
	}

	document.addEventListener("DOMContentLoaded", function () {
		initializeOnPageLoad();
	});

	if (typeof window.subscribe === "function") {
		window.subscribe("cart-update", function (data) {
			if (data && data.cartData) {
				updateAllFormsFromCart(data.cartData);
			}
		});
	}

	function updateCartCountBubble(cart) {
		const cartIconBubble = document.getElementById("cart-icon-bubble");
		if (!cartIconBubble) {
			return;
		}

		let cartCountBubble = cartIconBubble.querySelector(".cart-count-bubble");

		if (cart.item_count === 0) {
			if (cartCountBubble) {
				cartCountBubble.remove();
			}

			cartIconBubble.innerHTML = `
				<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
					<path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
				</svg>
				<span class="visually-hidden">Cart</span>
			`;
		} else {
			cartIconBubble.innerHTML = `
				<svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
					<path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
				</svg>
				<span class="visually-hidden">Cart</span>
			`;

			if (!cartCountBubble) {
				cartCountBubble = document.createElement("div");
				cartCountBubble.classList.add("cart-count-bubble");
				cartIconBubble.appendChild(cartCountBubble);
			}

			cartCountBubble.innerHTML = `
				${
					cart.item_count < 100
						? `<span aria-hidden="true">${cart.item_count}</span>`
						: ""
				}
				<span class="visually-hidden">Cart count: ${cart.item_count}</span>
			`;
		}

		const otherCartCounts = document.querySelectorAll("[data-cart-count]");
		otherCartCounts.forEach((el) => {
			el.textContent = cart.item_count;
			el.setAttribute("data-cart-count", cart.item_count);
		});
	}

	function showLoadingSpinner(button) {
		if (!button.querySelector(".loading__spinner")) {
			const spinner = document.createElement("div");
			spinner.classList.add("loading__spinner");
			spinner.innerHTML = `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>`;
			button.appendChild(spinner);
		}

		button.classList.add("loading");
		button.disabled = true;
		button.querySelector(".loading__spinner").classList.remove("hidden");
	}

	function hideLoadingSpinner(button) {
		button.classList.remove("loading");
		button.disabled = false;
		const spinner = button.querySelector(".loading__spinner");
		if (spinner) {
			spinner.classList.add("hidden");
		}
	}
})();
